<template>
  <div>
    <v-btn v-bind="{...$props, ...$attrs}"
           color="primary"
           @click.stop="dialog = true"
           class="mr-4"
    >
      Save
    </v-btn>

    <v-dialog
        v-model="dialog"
        max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          Do you want to save your changes?
        </v-card-title>

        <v-card-text>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              color="green darken-1"
              text
              @click="dialog = false"
          >
            Cancel
          </v-btn>

          <v-btn
              color="green darken-1"
              text
              @click="onSave"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  name: 'BaseConformSave',
  data() {
    return {
      dialog: false,
      dis: false,
    }
  },
  methods: {
    onSave() {
      this.dialog = false
      this.onSaveExternal()
    },
  },
  props: ['onSaveExternal', 'disabled']
}
</script>


<style scoped lang="scss">
</style>
